import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { getDarkModeStyle } from "../util";
import { ResetPasswordScreen } from "./reset-password-screen";
import { ForgotPasswordScreen } from "./forgot-password-screen";

export const ForgotPassword = ({ isUserLoginPage = false }) => {
  const { currentScreen = "forgotPassword" } = useSelector((state) => get(state, ["login", "forgotPassword"], {}));
  const mode = getDarkModeStyle();

  switch (currentScreen) {
    case "forgotPassword":
      return <ForgotPasswordScreen mode={mode} isUserLoginPage={isUserLoginPage} />;
    case "resetPassword":
      return <ResetPasswordScreen mode={mode} isUserLoginPage={isUserLoginPage} />;
  }
};
